import { PropsWithChildren } from "react";

import { tw } from "~/shared";
import { Styled } from "~/utils/types/StyledInterface";

export const ErrorText = ({
  children,
  className,
  id,
}: PropsWithChildren<Styled> & { id?: string }) => (
  <p
    id={id}
    role="alert"
    aria-live="assertive"
    className={tw("text-sm font-medium text-red-700", className)}
  >
    Error: {children}
  </p>
);
